export default __webpack_public_path__ + "static/media/overtime.7778a13e.png";